// eslint-disable-next-line import/prefer-default-export
export const instituteSortOptions = [
    {
        label: 'Name A-Z',
        value: {
            column: 'name',
            order: 'asc'
        }
    },
    {
        label: 'Name Z-A',
        value: {
            column: 'name',
            order: 'desc'
        }
    },
    // {
    //     label: 'City A-Z',
    //     value: {
    //         column: 'city',
    //         order: 'asc'
    //     }
    // },
    // {
    //     label: 'City Z-A',
    //     value: {
    //         column: 'city',
    //         order: 'desc'
    //     }
    // },
    // {
    //     label: 'State A-Z',
    //     value: {
    //         column: 'state',
    //         order: 'asc'
    //     }
    // },
    // {
    //     label: 'State Z-A',
    //     value: {
    //         column: 'state',
    //         order: 'desc'
    //     }
    // },
    {
        label: 'Last Updated Asc',
        value: {
            column: 'updatedAt',
            order: 'asc'
        }
    },
    {
        label: 'Last Updated Desc',
        value: {
            column: 'updatedAt',
            order: 'desc'
        }
    }
];
